export default {
  LOAD_MAJORS (state, payload) {
    state.majors = payload
  },
  LOAD_MINORS (state, payload) {
    state.minors = payload
  },
  LOAD_CAREERS (state, payload) {
    state.careers = payload
  },
  LOAD_INSTITUTION_CAREERS (state, payload) {
    state.institutionCareers = payload
  },
  LOAD_RECOMMENDED_CAREERS (state, payload) {
    state.recommendedCareers = payload
  },
  LOAD_INDUSTRIES (state, payload) {
    state.industries = payload
  },
  LOAD_CAREER_RESULTS (state, payload) {
    state.careerResults = payload
  },
  LOAD_PROGRAM_RESULTS (state, payload) {
    state.programResults = payload
  },
  LOAD_CURRENT_FACET (state, payload) {
    state.currentFacet = payload
  },
  UPDATE_PROGRAM_GUIDE_FACET_RESULTS (state, payload) {
    state.programGuideFacetResults = payload
  },
  UPDATE_PROGRAM_GUIDE_RESULTS (state, payload) {
    state.programGuideSearchResults = payload
  },
  UPDATE_CAREER_FACET_RESULTS (state, payload) {
    state.careerFacetResults = payload
  },
  UPDATE_CAREER_RESULTS (state, payload) {
    state.careerSearchResults = payload
  },
  LOAD_EXPLORE_SUBSTREAMS (state, payload) {
    state.substreams = payload
  },
  UPDATE_EXPLORE_STREAM (state, payload) {
    state.selectedStreamUuid = payload
  },
  UPDATE_EXPLORE_TIMESTAMP (state, payload) {
    state.lastUpdatedTime = payload
  },
  UPDATE_SELECTED_MAJOR (state, payload) {
    state.selectedMajor = payload
  },
  UPDATE_SELECTED_MINOR (state, payload) {
    state.selectedMinor = payload
  },
  UPDATE_SELECTED_INDUSTRY (state, payload) {
    state.selectedIndustry = payload
  },
  UPDATE_SELECTED_CAREER (state, payload) {
    state.selectedCareer = payload
  },
  LOAD_BOOKMARKS (state, payload) {
    state.bookmarks = payload
  },
  UPDATE_PROGRAM_GUIDE_SEARCH_TERMS (state, payload) {
    state.programGuideSearchTerms = payload
  },
  UPDATE_PROGRAM_GUIDE_SEARCH_SORT (state, payload) {
    state.programGuideSearchSort = payload
  },
  UPDATE_PROGRAM_GUIDE_SEARCH_FILTER (state, payload) {
    state.programGuideSearchFilter = payload
  },
  UPDATE_PROGRAM_GUIDE_SEARCH_SELECTED_FACET_NAMES (state, payload) {
    state.programGuideSearchSelectedFacetNames = payload
  },
  UPDATE_PROGRAM_GUIDE_SEARCH_INCOME_MIN (state, payload) {
    state.programGuideSearchCustomIncomeMin = payload
  },
  UPDATE_PROGRAM_GUIDE_SEARCH_INCOME_MAX (state, payload) {
    state.programGuideSearchCustomIncomeMax = payload
  },
  UPDATE_CAREER_SEARCH_TERMS (state, payload) {
    state.careerSearchTerms = payload
  },
  UPDATE_CAREER_SEARCH_SORT (state, payload) {
    state.careerSearchSort = payload
  },
  UPDATE_CAREER_SEARCH_FILTER (state, payload) {
    state.careerSearchFilter = payload
  },
  UPDATE_CAREER_SEARCH_SELECTED_FACET_NAMES (state, payload) {
    state.careerSearchSelectedFacetNames = payload
  },
  UPDATE_CAREER_SEARCH_INCOME_MIN (state, payload) {
    state.careerSearchCustomIncomeMin = payload
  },
  UPDATE_CAREER_SEARCH_INCOME_MAX (state, payload) {
    state.careerSearchCustomIncomeMax = payload
  },
  LOAD_PROGRAM_TOTAL (state, payload) {
    state.programTotal = payload
  },
  LOAD_CAREER_TOTAL (state, payload) {
    state.careerTotal = payload
  },
  LOAD_PROGRAM_SCROLL_TOP (state, payload) {
    state.programScrollTop = payload
  },
  LOAD_PROGRAM_SCROLL_LEFT (state, payload) {
    state.programScrollLeft = payload
  },
  LOAD_CAREER_SCROLL_TOP (state, payload) {
    state.careerScrollTop = payload
  },
  LOAD_CAREER_SCROLL_LEFT (state, payload) {
    state.careerScrollLeft = payload
  },
  UPDATE_CAREER_SEARCH_INSTITUTION_CAREER_FILTER (state, payload) {
    state.careerSearchInstitutionCareerFilter = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/explore/vuex/mutations.js